// extracted by mini-css-extract-plugin
export default {"modal":"A9IwAX9pRMi3v0PnLBQ9","close":"eu2tsj1X0Kt15BpodX73","submit":"UbKF6LUgFq5aime8hbL3"};